<template>
  <v-dialog
    v-model="active"
    width="70%"
    persistent
  >
    <v-card color="primary">
      <v-card-title>
        <div class="text-h6">
          Evaluacion psicológica
        </div>
        <v-spacer />
        <v-btn
          icon
          color="error"
          @click="closeDialog()"
        >
          <v-icon>mdi-window-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text v-if="evaluacionPsicologica">
        <v-container>
          <v-row>
            <v-col cols="3">
              <v-text-field
                label="Evaluado"
                :value="getFullName(
                  evaluacionPsicologica.Derivacion.Programacion.Expediente.Personal)"
                rounded
                filled
                dense
                color="secondary"
                background-color="primary"
                readonly
              />
            </v-col>
            <v-col cols="3">
              <v-text-field
                label="Evaluador"
                :value="evaluacionPsicologica.CatEvaluador.evaluador"
                rounded
                filled
                dense
                color="secondary"
                background-color="primary"
                readonly
              />
            </v-col>
            <v-col cols="6">
              <v-text-field
                label="Diagnóstico"
                :value="evaluacionPsicologica.CatDiagnostico.title"
                rounded
                filled
                dense
                color="secondary"
                background-color="primary"
                readonly
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <v-card
                class="card"
                color="primary"
              >
                <v-list
                  dense
                  color="transparent"
                >
                  <v-list-item>
                    <v-list-item-icon>
                      <v-icon
                        v-if="evaluacionPsicologica.aptoArmaFuego"
                        color="success"
                      >
                        mdi-check
                      </v-icon>
                      <v-icon
                        v-else
                        color="error"
                      >
                        mdi-window-close
                      </v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title v-if="evaluacionPsicologica.aptoArmaFuego">
                        El evaluado es apto para portar arma de fuego
                      </v-list-item-title>
                      <v-list-item-title v-else>
                        El evaluado no es apto para portar arma de fuego
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-icon>
                      <v-icon
                        v-if="evaluacionPsicologica.accidentesArmaFuego"
                        color="error"
                      >
                        mdi-thumb-down
                      </v-icon>
                      <v-icon
                        v-else
                        color="success"
                      >
                        mdi-thumb-up
                      </v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title v-if="evaluacionPsicologica.accidentesArmaFuego">
                        El evaluado ha tenido accidentes con arma de fuego
                      </v-list-item-title>
                      <v-list-item-title v-else>
                        El evaluado no ha tenido accidentes con arma de fuego
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-icon>
                      <v-icon
                        v-if="evaluacionPsicologica.accidentesPatrulla"
                        color="error"
                      >
                        mdi-thumb-down
                      </v-icon>
                      <v-icon
                        v-else
                        color="success"
                      >
                        mdi-thumb-up
                      </v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title v-if="evaluacionPsicologica.accidentesPatrulla">
                        El evaluado ha tenido accidentes con patrulla
                      </v-list-item-title>
                      <v-list-item-title v-else>
                        El evaluado no ha tenido accidentes con patrulla
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-col>
            <v-col cols="3">
              <v-card
                class="card"
                color="primary"
              >
                <v-card-text align="center">
                  <div class="text-h4 font-weight-bold">
                    {{ evaluacionPsicologica.experienciaSP }}
                  </div>
                  <div class="text-subtitle-2">
                    Años de experiencia en seguridad pública
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="3">
              <v-card
                class="card"
                color="primary"
              >
                <v-card-title class="justify-center">
                  Motivos de resultado
                </v-card-title>
                <v-card-text>
                  <v-list color="transparent">
                    <v-list-item
                      v-for="(motivo, index) in evaluacionPsicologica.motivosResultado"
                      :key="index"
                    >
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ motivo.CatMotivoResultado.title }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12">
              <v-textarea
                v-model="evaluacionPsicologica.trayectoriaLaboral"
                label="Trayectoria laboral"
                rows="6"
                rounded
                filled
                dense
                color="secondary"
                background-color="primary"
                no-resize
                readonly
              />
            </v-col>
            <v-col cols="12">
              <v-textarea
                v-model="evaluacionPsicologica.fortalezas"
                label="Fortalezas"
                rows="6"
                rounded
                filled
                dense
                color="secondary"
                background-color="primary"
                no-resize
                readonly
              />
            </v-col>
            <v-col cols="12">
              <v-textarea
                v-model="evaluacionPsicologica.areasOporunidad"
                label="Áreas de oportunidad"
                rows="6"
                rounded
                filled
                dense
                color="secondary"
                background-color="primary"
                no-resize
                readonly
              />
            </v-col>
            <v-col cols="12">
              <v-textarea
                v-model="evaluacionPsicologica.observaciones"
                label="Observaciones"
                rows="3"
                rounded
                filled
                dense
                color="secondary"
                background-color="primary"
                no-resize
                readonly
              />
            </v-col>
            <v-col cols="12">
              <v-textarea
                v-model="evaluacionPsicologica.conclusiones"
                label="Conclusiones"
                rows="3"
                rounded
                filled
                dense
                color="secondary"
                background-color="primary"
                no-resize
                readonly
              />
            </v-col>
            <v-col
              v-if="evaluacionPsicologica.URL !== ''"
              cols="3"
            >
              <v-card
                class="card"
                color="primary"
              >
                <v-card-text>
                  <v-btn
                    small
                    text
                    color="secondary"
                    block
                    @click="download(evaluacionPsicologica.URL)"
                  >
                    <v-icon class="mr-2">
                      mdi-file-download
                    </v-icon>
                    Funciones que desempeña
                  </v-btn>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    active: {
      type: Boolean,
    },

    evaluacionPsicologica: {
      type: Object,
      required: true,
    },
  },

  methods: {
    closeDialog() {
      this.$emit('close');
    },
  },
};
</script>
